import ApiRequests from "../apiRequests";

class CategoryService extends ApiRequests {
  constructor() {
    super("categories");
  }
}

export default CategoryService;
